<template>
  <div class="resource">
    <header>
      <div class="grade-list">
        <div v-for="(grade, index) in grades" :key="index" class="grade" :style="{ visibility: grade.visible ? 'visible' : 'hidden' }">
          <input :id="`grade-${index}`" name="grade" type="radio" :value="grade.value" @change="change(grade.version)" :checked="grade.checked">
          <label :for="`grade-${index}`" class="cursor text-hover">{{ grade.label }}</label>
        </div>
      </div>
    </header>
    <div class="content">
      <div class="title needCenter">
        <h2>动态课件-{{ version }}</h2>
      </div>
      <div class="hint needCenter">本套动态课件由新世纪小学数学教材编委会与网络画板官方共同设计开发。目前在测试期，在此期间大家可以免费使用。您可以通过复制链接到浏览器、分享链接到qq群微信群、手机平板扫描二维码等方式进行访问。具体请看使用帮助。使用过程中有任何问题和建议欢迎您随时反馈。<a target="_blank" href="https://jznetpad.feishu.cn/docx/GfvodSBWpoFkhAx4CdycFR8gnvb?from=from_copylink">使用帮助</a> <a target="_blank" href="https://jznetpad.feishu.cn/share/base/form/shrcn24aVUqhyYh4XVBmgxSFPZe">意见反馈</a></div>
      <div class="resourceCard needCenter">
        <resourceCard 
        v-for="(resource,index) in resources" 
        :key="index" 
        :resource="resource"
        @resource_play = 'resource_play'
        />
      </div>
    </div>

    <resourceDialog v-if="resourcePlay" :resource = showResource @closed="closed"/>

  </div>
</template>

<script>
const XLSX = require('xlsx');
import resourceCard from '../components/resourceCard.vue'
import resourceDialog from '../components/resourceDialog.vue'
export default {
  name: '',
  props: {
  },
  data () {
    return {
      grades: [
        { label: '一年级上', value: '1', version: '1上', visible: true, checked:true  },
        { label: '一年级下', value: '2', version: '1下', visible: true},
        { label: '二年级上', value: '3', version: '2上', visible: true },
        { label: '二年级下', value: '4', version: '2下', visible: true },
        { label: '三年级上', value: '5', version: '3上', visible: true },
        { label: '三年级下', value: '6', version: '3下', visible: true },
        { label: '四年级上', value: '7', version: '4上', visible: true },
        { label: '5年级上', value: '6', version: '5上', visible: false },
        { label: '6年级上', value: '7', version: '6上', visible: false },
      ],
      resources:[],
      resourcePlay:false,
      showResource:null,
      version:'1上'
    }
  },
  components: {resourceCard,resourceDialog},
  created () {},
  mounted () {
    this.getExcelData(this.version)
  },
  methods: {
    async getExcelData(version){
      try {
        const url = `${process.env.VUE_APP_BASE_LOGIN}/download/xsj/${version}/新世纪小学数学课件.xlsx`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('获取Excel文件失败');
        }
        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'buffer' });
        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];
        this.resources = XLSX.utils.sheet_to_json(sheet)
        
      } catch (error) {
        console.error('Error loading Excel file:', error);
        this.resources = 'Error: ' + error.message;
      }
    },
    resource_play(resource){
      this.showResource = resource
      this.resourcePlay = true
    },
    closed(){
      this.resourcePlay = false
    },
    async change(version){
      this.resources = []
      this.version = version
      await this.getExcelData(version)
    }
  }
}
</script>

<style lang="less" scoped>

.resource{
  width: 100%;
  header{
    display: flex;
    align-items: center;
    width: 100%;
    height: 110px;
    justify-content: center;
    background-color: #eaebee;
    .grade-list{
      height: 50px;
      background-color: #fff;
      width: 1140px;
      color: #666;
      font-size: 14px;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .grade{
        display: flex;
        flex: 1;
        height: 100%;
        align-items: center;
        justify-content: center;
        input{
          display: none;
        }
        input:checked+label{
          background-color: #35a7ff;
          color: #fff;
        }
        label{
          display: block;
          height: 100%;
          width: 100%;
          font-size: 14px;
          line-height: 50px;
          text-align: center;
          transition: all .2s ease-in-out;
        }
      }
    }
  }
  .content{
    width: 100%;
    margin-bottom: 30px;
    .needCenter{
      margin: auto;
    }
    .title{
      font-size: 20px;
      color: #333;
      width: 1140px;
      padding: 30px 0;
      font-weight: 600;
      h2{
        font-size: 20px;
        color: #333;
        margin-bottom: .5em;
        font-weight: 500;
      }
    }
    .hint{
      padding: 12px 10px;
      width: 1110px;
      border: 2px solid #e8c117;
      border-radius: 5px;
      color: #65650c;
    }
    .resourceCard{
      overflow: auto;
      width: 1140px;
      padding-top: 10px;
    }
    
    
  }
}

.cursor{
  cursor: pointer;
  user-select: none;
}
a{
  margin-left:10px;
  color: #4164da;
}

@media screen and (max-width: 1440px) and (min-width: 1140px) {
    .resource header .grade-list, .resource .content .title, .resource .content .hint, .resource .content .resourceCard{
        width: 1140px;
    }
}
@media screen and (max-width: 1140px) and (min-width: 960px) {
    .resource header .grade-list, .resource .content .title, .resource .content .hint, .resource .content .resourceCard{
        width: 850px;
    }
}
@media screen and (max-width: 960px) and (min-width: 576px) {
    .resource header .grade-list, .resource .content .title, .resource .content .hint, .resource .content .resourceCard{
        width: 560px;
    }
}
@media screen and (max-width: 576px) {
  .resource header .grade-list,.resource .content .title,.resource .content .hint, .resource .content .resourceCard{
        width:396px;
    }
}
@media screen and (max-width: 450px) {
  .resource header .grade-list,.resource .content .title,.resource .content .hint, .resource .content .resourceCard{
        width:95%;
    }
}
</style>
